const base = {
  clearAll: (itemsToClear) => `Clear all (${itemsToClear})`,
  selectAll: (itemsToSelect) => `Select all (${itemsToSelect})`,
  noOptions: "No Options",
  clearSearch: `Clear search`
};
function getDefaultTexts(texts) {
  return {
    clearAll: texts?.clearAll ?? base.clearAll,
    selectAll: texts?.selectAll ?? base.selectAll,
    noOptions: texts?.noOptions ?? base.noOptions,
    clearSearch: texts?.clearSearch ?? base.clearSearch
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
